import { useEffect } from 'react';
import { SERVICE_URL } from '@/lib/brand';

type Options = {
  /** 正規 URL (SERVICE_URL からの相対パス。例 '/'、'/report/sample')。検索に載せるページだけ指定する。 */
  canonical?: string;
  /** true なら検索に載せない (調査結果の URL や 404)。 */
  noindex?: boolean;
};

// ページごとの canonical / robots。SPA なので <head> を画面側で書く (Google は JS 描画後の head を読む)。
// 正規 URL は常に本番 (kenchiku-chino.com/tochi-check/) を指す: 確認用の *.cloudfront.net でも同じ値になり、
// 評価が本番にまとまる。パートナー版のビルドは index.html に noindex が静的に入っているので何もしない。
export function usePageSeo({ canonical, noindex }: Options): void {
  useEffect(() => {
    if (import.meta.env.VITE_PARTNER) return;
    const head = document.head;
    const added: Element[] = [];
    if (canonical) {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = new URL(canonical.replace(/^\//, ''), SERVICE_URL).href;
      head.appendChild(link);
      added.push(link);
    }
    if (noindex) {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex, nofollow';
      head.appendChild(meta);
      added.push(meta);
    }
    return () => {
      for (const el of added) el.remove();
    };
  }, [canonical, noindex]);
}
